import { useState } from "react";
import { ApiError } from "../../services/api.service";

interface UseDownloadContractReturn {
	downloading: boolean;
	error: string | null;
	downloadContract: (contractId: number) => Promise<void>;
}

/**
 * Download user contract PDF.
 * Uses <a> download approach — works on all browsers including Safari/iOS without popups.
 */
export function useDownloadContract(): UseDownloadContractReturn {
	const [downloading, setDownloading] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);

	const downloadContract = async (contractId: number): Promise<void> => {
		try {
			setDownloading(true);
			setError(null);

			const token = localStorage.getItem("accessToken");
			if (!token) {
				throw new Error("Keine Authentifizierung verfügbar");
			}

			const response = await fetch(
				`${import.meta.env.VITE_API_URL || "http://localhost:3001/api"}/contracts/${contractId}/download`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (!response.ok) {
				throw new Error(`Fehler beim Herunterladen: ${response.statusText}`);
			}

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = url;
			link.download = `Vertrag.pdf`;
			document.body.appendChild(link);
			link.click();
			setTimeout(() => {
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}, 1000);
		} catch (err) {
			if (err instanceof ApiError) {
				setError(err.message);
			} else if (err instanceof Error) {
				setError(err.message);
			} else {
				setError("Ein unerwarteter Fehler ist beim Herunterladen aufgetreten");
			}
			throw err;
		} finally {
			setDownloading(false);
		}
	};

	return {
		downloading,
		error,
		downloadContract,
	};
}
